/**
 * Diccionario único de labels en español para los criterios de calidad de
 * entrega. Centralizar acá evita drift entre tabs (Global, Driver, etc.) y
 * garantiza que `top_issues` y `by_criterion` se muestren con el mismo nombre
 * de cara al usuario.
 */
export const CRITERION_LABEL = {
  rut: 'RUT del receptor',
  receiver: 'Nombre del receptor',
  distance: 'Distancia (< 100 m)',
  timeliness: 'Puntualidad (antes 21:00)',
  image_count: 'Cantidad de fotos',
  images_ai: 'Análisis IA de fotos',
};

export const labelForCriterion = (key) => CRITERION_LABEL[key] || key;
